/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jslint browser: true, unparam: true */

"use strict";

var ko = require("knockout");

var $ = require("../jquery");
var setFieldDisabledUpdater = require("../knockout/pliDisableField").setFieldDisabledUpdater;
var setFieldFocusRegistrator = require("../knockout/pliHasFocus").setFieldFocusRegistrator;
var setFieldFocusUpdater = require("../knockout/pliHasFocus").setFieldFocusUpdater;
var setFieldReadonlyUpdater = require("../knockout/pliReadOnlyField").setFieldReadonlyUpdater;


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// The "pliMultiselect" binding
// The binding that goes with the multiselect behaviour
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function bindSpanToObservable($spanControl, observable) {
    var updatingFilter = false;
    $spanControl.bind('blur keyup paste copy cut mouseup', function () {
        updatingFilter = true;
        observable($spanControl.text());
        updatingFilter = false;
    });
    observable.subscribe(function (text) {
        if (!updatingFilter) {
            $spanControl.text(text);
        }
    });
}

//-------------------------------------------
function toggleContentEditableAndDisable(element, disabled) {
    $(element).find("[contenteditable]").attr("contenteditable", !disabled);
    ko.utils.toggleDomNodeCssClass(element.parentNode.parentNode, "disabled", disabled);
}

//-------------------------------------------
function toggleContentEditableAndReadOnly() {
    throw new Error("Readonly binding is not supported for multiselect controls");
}

//-------------------------------------------
ko.bindingHandlers.pliMultiselect = {
    init: function (element, valueAccessor) {
        var value = valueAccessor(),
            $element = $(element),
            $control,
            $dropdown,
            data = {
                $errorText: $element.find("b.withError"),
                $p: $element.closest("p, li, div.pliControl"),
                msViewModel: value.multiSelectViewModel,
                observable: value
            };

        if (element.tagName.toUpperCase() !== "SPAN") {
            throw new Error("pliMultiselect binding may only be applied to SPAN elements");
        }

        if (!ko.isWriteableObservable(value)) {
            throw new Error("Target of pliMultiselect binding must be a writeable observable");
        }

        if (!value.multiSelectViewModel || typeof value.multiSelectViewModel !== "object") {
            throw new Error("pliMultiselect binding requires target ko.observablePliTextBox instance to use multiSelect behaviour");
        }

        var placeholder = ((value.behaviourData && value.behaviourData.placeholder)
            || $element.attr('data-placeholder')
            || $element.attr('placeholder'));

        if (placeholder) {
            value.multiSelectViewModel._setPlaceholder(placeholder);
        }

        // empty old items
        $element.empty();

        // create items
        $control = $(ko.bindingHandlers.pliMultiselect.templates.control);
        $element.append($control);
        ko.applyBindings(value.multiSelectViewModel, $control[0]);

        // set control to viewModel
        value.multiSelectViewModel.$container($control);

        // add progress and failure CSS classes based on picklist data state
        value.state.subscribe(function (state) {
            data.$p.toggleClass("withProgress", state.isBusy)
                .toggleClass("withFailure", state.isFailed);
        });

        // Append the error text DOM element if not available
        if (!data.$errorText.length) {
            data.$errorText = $("<b class=\"withError\"></b>");
            data.$p.append(data.$errorText);
        }

        // enable picklist icon to open dialog
        $element.parent().on("mousedown", ">i", function pliMultiselectIconClick() {
            value.multiSelectViewModel.showDialog();
        });

        // bind editable span to filter on viewmodel
        data.$input = $control.find(".ms-input");
        bindSpanToObservable(data.$input, value.multiSelectViewModel.filter);

        setFieldFocusRegistrator(element, function (handleElementFocusIn, handleElementFocusOut) {
            var inputSpan = data.$input[0];
            ko.utils.registerEventHandler(inputSpan, "focus", handleElementFocusIn);
            ko.utils.registerEventHandler(inputSpan, "focusin", handleElementFocusIn); // for IE
            ko.utils.registerEventHandler(inputSpan, "blur", handleElementFocusOut);
            ko.utils.registerEventHandler(inputSpan, "focusout", handleElementFocusOut); // for IE
        });

        setFieldFocusUpdater(element, function (focusToSet) {
            data.msViewModel.isFocused(focusToSet);
        });

        // add dropdown to the bottom of the page, to use with absolute positioning
        $dropdown = $(ko.bindingHandlers.pliMultiselect.templates.dropdownContainer);
        $("body").append($dropdown);
        ko.applyBindings(value.multiSelectViewModel, $dropdown[0]);

        // wrap dropdown with "skipBindings"
        $dropdown.wrap($(ko.bindingHandlers.pliMultiselect.templates.skipBindings));

        // attach data to element
        $element.data("data", data);

        // shim controller until multiselect is refactored to use "pliTextBox" binding
        value._controllers.push({
            updateView: function () {
                data.$errorText.text(value._errorMessage || "");
                if (value._errorMessage) {
                    data.$p.addClass("withError");
                } else {
                    data.$p.removeClass("withError");
                }
            },
            _applyChanges: function () {
                // _applyChanges required to avoid NPE
                return; // lint
            }
        });

        setFieldDisabledUpdater(element, toggleContentEditableAndDisable);
        setFieldReadonlyUpdater(element, toggleContentEditableAndReadOnly);

        return { controlsDescendantBindings: true };
    },
    update: function (element, valueAccessor) {
        var $element = $(element),
            data = $element.data("data"),
            o = valueAccessor(),
            stateObservable = o.state;

        // detect changes of the bound observable and update the multiselect view model
        if (data.observable !== o) {
            data.observable = o;
            // temporary disable updates to the bound observable to update mutliSelect view model selected items
            data.msViewModel.callback = null;
            data.msViewModel.setSelectedItemsFromArray(o.peek() || []);
            // set the multiSelect view model callback to the currently bound observable selected items update handler
            data.msViewModel.callback = o._updateValues;
        }

        // need to revalidate observables because valueAccessor result could have changed
        if (!ko.isObservable(stateObservable)) {
            throw new Error("target of data-binding must have state observable");
        }

        // Ensure state trigger update
        var state = stateObservable();

        // re-format error text and error state
        data.$errorText.text(state.message || "");
        data.$p.toggleClass("withError", !state.isValid);
    }
};

//-------------------------------------------
ko.bindingHandlers.pliMultiselect.templates = {
    control:  "<span class='ms-container' data-bind='event: { click: openList, mousedown: focus }, css: { focused: isFocused }'>" +
                "<!-- ko foreach: selectedItems -->" +
                    "<span unselectable='on' class='ms-item' data-bind='css: { \"ms-error\": isError, \"ms-category\": isCategory, \"ms-selected\": $root.isCurrentItem($data)}, attr: {id: \"item_\" + index}, event: {click: $root.setCurrentItem } '>" +
                        "<span unselectable='on' class='ms-text' data-bind='text: text'></span>" +
                        "<i unselectable='on' class='sprite-smallX-16' data-bind='event: {mousedown: $root.unSelectItem}'></i>" +
                    "</span>" +
                "<!-- /ko -->" +
                // placeholder
                "<!-- ko if: placeholder && selectedItems && selectedItems().length === 0 && !isFocused() -->" +
                    "<span class='ms-placeholder' data-bind='text: placeholder'></span>" +
                "<!-- /ko -->" +
                // text box
                "<span class='ms-input' contenteditable='true' data-bind='hasfocus: isFocused, event: { keydown: handleKeyDown, keyup: handleKeyUp, blur: removeFocus }, attr: { contenteditable: isEnabled() }'></span>" +
              "</span>",
    dropdownContainer: "<div unselectable='on' class='ms-dropdown-container' data-bind='multiSelectVisibleAnchor: {visible: isListOpen, anchor: $container, width: _options.dropdownWidth }, " +
                            "multiSelectScrollTop: scrollTop, virtualScroll: { items: filteredItems, size: _options.listItemHeight, " +
                                "containerTemplate: ko.bindingHandlers.pliMultiselect.templates.dropdown, " +
                                "itemTemplate: ko.bindingHandlers.pliMultiselect.templates.dropdownItem }," +
                             "style: {height: listHeight() + \"px\"}' ></div>",
    // dropdown list template
    dropdown:   "<ul unselectable='on' class='ms-dropdown'></ul>",

    dropdownItem: "".concat(
        "<li data-bind='",
        "click: $root.selectItem.bind($data, $data),",
        "event: { mouseover: $root.setCurrentListItem.bind(null, $data), mousedown: function() { return false; } },",
        "css: { category: $data.isCategory, selected: $root.isCurrentListItem($data) },",
        "value: $data.value'><div data-bind='text: $data.text, style: { lineHeight: $root._options.listItemHeight + \"px\" }'></div></li>"
    ),

    // div, to mark dropdown list as not allow further bindings
    skipBindings: "<div data-bind='stopBinding: true'></div>"
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// The "multiSelectScrollTop" binding
// Two way binding of the scroll top property
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
ko.bindingHandlers.multiSelectScrollTop = {
    init: function (element, valueAccessor) {
        var value = valueAccessor(),
            $element = $(element),
            timer = 0,
            delay = 50, //you can tweak this value

            handler = function () {
                timer = 0;
                value($element.scrollTop());
            };

        // on element scroll - update scrollTop value
        $element.scroll(function () {
            if (timer) {
                window.clearTimeout(timer);
                timer = 0;
            }
            timer = setTimeout(handler, delay);
        });
    },
    update: function (element, valueAccessor) {
        var value = valueAccessor();
        $(element).scrollTop(ko.utils.unwrapObservable(value));
    }
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//  The "multiSelectVisibleAnchor" binding
//  Shows element at the bottom/top of the anchor element
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
ko.bindingHandlers.multiSelectVisibleAnchor = {
    init: function (element, valueAccessor) {
        // if window resized - force update of visibility
        $(window).resize(function () {
            var value = ko.utils.unwrapObservable(valueAccessor);
            value().visible.valueHasMutated();
        });
    },
    update: function (element, valueAccessor) {
        var viewModel = valueAccessor(),
            $window = $(window),
            $element = $(element),
            isVisible = ko.utils.unwrapObservable(viewModel.visible),
            anchorElement = ko.utils.unwrapObservable(viewModel.anchor),
            anchorElementOffset = anchorElement.offset(),
            anchorElementHeight = anchorElement.outerHeight(false),
            dropTop = anchorElementOffset.top + anchorElementHeight,
            dropHeight = $element.outerHeight(false),
            dropLeft = anchorElementOffset.left,
            viewportBottom = $window.scrollTop() + $window.height(),
            width = ko.utils.unwrapObservable(viewModel.width) || (anchorElement.outerWidth() - 2), // fix css border size - 2 px
            enoughRoomBelow = dropTop + dropHeight <= viewportBottom;
        if (isVisible) {
            if (!enoughRoomBelow) {
                dropTop = anchorElementOffset.top - dropHeight;
            }

            $element.css({
                top: dropTop + "px",
                left : dropLeft + "px",
                width: width
            });
            $element.show();
        } else {
            $element.hide();
        }
    }
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-knockoutcontrols-multiselect/pliMultiselectBinding.js
// module id = 443
// module chunks = 49